import { useEffect, useState, useCallback } from 'react';
import { CrudTableEvents } from './Crud.types';

interface IUseAddRecordButtonParams {
  disabled?: boolean;
}

interface IUseAddRecordButtonReturn {
  handleClick: () => void;
  isDisabled: boolean;
}

export const useAddRecordButton = ({ disabled = false }: IUseAddRecordButtonParams): IUseAddRecordButtonReturn => {
  const [isTableLoading, setIsTableLoading] = useState(false);

  useEffect(() => {
    const disableButton = (): void => {
      setIsTableLoading(true);
    };
    const enableButton = (): void => {
      setIsTableLoading(false);
    };

    document.addEventListener(CrudTableEvents.TableIsLoading, disableButton);
    document.addEventListener(CrudTableEvents.TableIsReady, enableButton);

    return () => {
      document.removeEventListener(CrudTableEvents.TableIsLoading, disableButton);
      document.removeEventListener(CrudTableEvents.TableIsReady, enableButton);
    };
  }, []);

  const handleClick = useCallback((): void => {
    document.dispatchEvent(new Event(CrudTableEvents.AddNewClicked));
  }, []);

  return { handleClick, isDisabled: disabled || isTableLoading };
};
